
import React, { Component } from 'react';

export default class Support extends Component {
    state = {
        value: 0,
      };
    render(){
        return(
            <div>
                    <h5>Support</h5>
                    <br /><br /><br />
            We offer world class support - which can be tailored to you and your business
            regardless of whether it's a one time call or
            our monthly support as a service which starts from £29/month. This is regardless of the size of your website
            or type of web application.<br />More details can be found below for each support function.



            </div>
        );
    }
  }


// WEBPACK FOOTER //
// ./src/components/Support.js